export const PATH_GET_METERS_FROM_COMPANY_WITH_BRANCHES = '/api/v2/branch';
export const PATH_GET_METERS_FROM_BRANCH = '/api/v2/egg';
export const PATH_GET_METERS_FROM_COMPANY = '/api/v2/egg';
export const PATH_METERS = '/api/v2/meter';
